import { CustomerSales } from '../translations-types';

const translations: CustomerSales = {
  title: 'Sales',
  date: 'Date',
  order: 'Order',
  type: 'Type',
  description: 'Description',
  employee: 'Employee',
  quantity: 'Qty',
  discount: 'Discount',
  total: 'Total',
  sum: 'Total',
  subtotal: 'Subtotal',
  service: 'Service',
  product: 'Product',
  all: 'All',
  services: 'Services',
  products: 'Products',
  noSales: 'No sales yet',
};

export default translations;
